import {MIN_SEARCH_LENGTH} from '../../consts';

import {FIELD_NAME, FIELD_ADDRESS, FIELD_DESCRIPTION} from './consts';
// @ts-expect-error
import {AccountFormFieldTypes} from './types';

export const shouldShowPotentialAccounts = (
    name?: string | null,
    description?: string | null,
    address?: string | null
) => {
    return (
        (name && name.length >= MIN_SEARCH_LENGTH) ||
        (description && description.length >= MIN_SEARCH_LENGTH) ||
        (address && address.length >= MIN_SEARCH_LENGTH)
    );
};

export const shouldAllowCreate = (
    isTemporary: boolean,
    name?: string | null,
    address?: string | null
) => {
    return (
        !isTemporary &&
        ((name && name.length >= MIN_SEARCH_LENGTH) ||
            (address && address.length >= MIN_SEARCH_LENGTH))
    );
};

export const handleKeyboardNavigation = (
    e: React.KeyboardEvent,
    currentField: AccountFormFieldTypes,
    addressRef: React.Ref<HTMLInputElement | null | undefined | null>,
    descriptionRef: React.Ref<HTMLInputElement | null | undefined | null>,
    nameRef: React.Ref<HTMLInputElement | null | undefined | null>
) => {
    switch (e.key) {
        case 'ArrowDown':
            if (currentField === FIELD_NAME)
                // @ts-expect-error
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                descriptionRef.current && descriptionRef.current.focus();
            if (currentField === FIELD_DESCRIPTION)
                // @ts-expect-error
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                addressRef.current && addressRef.current.focus();
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            if (currentField === FIELD_ADDRESS) nameRef.current && nameRef.current.focus();
            break;
        case 'ArrowUp':
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            if (currentField === FIELD_NAME) addressRef.current && addressRef.current.focus();
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            if (currentField === FIELD_DESCRIPTION) nameRef.current && nameRef.current.focus();
            if (currentField === FIELD_ADDRESS)
                // @ts-expect-error
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                descriptionRef.current && descriptionRef.current.focus();
            break;
    }
};
